import React from 'react'
import { Title } from './styles'
import { transformDate } from '~/utils'

export interface SessionTitleProps {
  title: string
  descriptionDate?: string
}

export const SessionTitle = ({ title, descriptionDate }: SessionTitleProps): JSX.Element => {
  if (descriptionDate) {
    return <Title>{`${title} - ${transformDate({ date: descriptionDate })}`}</Title>
  }

  return <Title>{title}</Title>
}
